import React from "react";
import { PageHero, Section, Eyebrow } from "@/components/PageParts";
import { Card } from "@/components/ui/card";
import { PoweredByEagle } from "@/components/Brand";
import { ShieldCheck, Target, Scale } from "lucide-react";

export default function About() {
  return (
    <div>
      <PageHero eyebrow="About" title="An institutional placement platform"
        subtitle="Care Placement Pro is a private-pay healthcare placement education, agent-network, and business-building platform — powered by the real-world healthcare operating experience of Eagle Healthcare Services, Inc." />
      <Section className="py-20">
        <div className="grid gap-12 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Eyebrow>Our mission</Eyebrow>
            <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-navy">
              Teaching how private-pay placement works
            </h2>
            <div className="mt-5 space-y-4 text-slate-600">
              <p>
                Care Placement Pro teaches people how to identify private-pay healthcare and support-service needs,
                develop provider networks, build professional referral relationships, connect consumers with appropriate
                participating providers, use AI to automate business development, and potentially build an independent
                placement company.
              </p>
              <p>
                We are an institutional brand. Public-facing authority comes from Care Placement Pro, the Care Placement
                Pro Training Team, Eagle Healthcare Services, Inc., and the Eagle Healthcare Education Team — not from any
                single individual.
              </p>
              <p>
                We do not imply employment, and we do not guarantee placements, commissions, customers, revenue, or
                earnings. Compensation depends on approved written arrangements and applicable law, always with a
                private-pay first focus.
              </p>
            </div>
          </div>
          <div className="space-y-5">
            {[[ShieldCheck, "Compliance-first", "Built-in gates for government payers and sensitive services."],
              [Target, "Private-pay focus", "Architected around available private-pay care capacity."],
              [Scale, "Lawful & transparent", "Approved written agreements define all compensation."]].map(([Icon, t, d]) => (
              <Card key={t} className="flex gap-4 p-6">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-sky">
                  <Icon className="h-5 w-5 text-clinical" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-navy">{t}</p>
                  <p className="mt-1 text-sm text-slate-500">{d}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
        <div className="mt-14 border-t border-slate-200 pt-8">
          <PoweredByEagle />
        </div>
      </Section>
    </div>
  );
}
